export default "__VITE_ASSET__CFijqJFA__"